// extracted by mini-css-extract-plugin
export var cardHeader = "_ju-1";
export var contentCard = "_ju-0";
export var headerActions = "_ju-3";
export var reorderHandle = "_ju-5";
export var titleArea = "_ju-2";
export var titleAreaWithHandle = "_ju-4";